import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: sessionStorage.getItem('state')
    ? JSON.parse(sessionStorage.getItem('state'))
    : {
        // 侧边栏当前默认选中索引
        activeIndex: 0,
        logout: false, // 是否注销默认为否
        clientHeight: 0, // 监听浏览器高度
        clientWidth: 0, // 监听浏览器宽度
        showLoading: 0, // 是否显示遮罩
        accessToken: '', // token
        refreshToken: '', // 刷新token
        expirationTime: 0, // token有效时间
        effectiveMinutes: 0, // token有效分钟数
        openMenusList: [
          {
            id: 2,
            menuName: '首页',
            iconFont: '',
            path: '/HomePage',
            pinyin: ''
          }
        ],
        // 菜单列表
        menulist: [],
        // 用户信息
        userInfo: {},
        // 汇总界面当前选中的产品类型
        productType: '',
        // 系统设置
        systemSetting: {
          theme: 'default',
          defaultSearch: 'all',
          explainSort: 'desc',
          ifShowQuestionDetail: 'no',
          todoDefaultShow: '未完成'
        },
        ykDivider: 33,
        // ip以及物理地址
        ipAndAddress: {
          ip: '',
          address: ''
        },
        // 是否移动端
        isMobile: false
      },
  mutations: {
    // 设置是否移动端
    set_isMobile(state, isMobile) {
      state.isMobile = isMobile
    },
    // 设置IP
    set_ipAndAddress(state, ipAndAddress) {
      state.ipAndAddress = ipAndAddress
    },
    // 设置员工信息
    set_userInfo(state, userInfo) {
      this.state.userInfo = userInfo
    },
    // 设置accessToken
    set_accessToken(state, accessToken) {
      this.state.accessToken = accessToken
    },
    // 设置refreshToken
    set_refreshToken(state, refreshToken) {
      this.state.refreshToken = refreshToken
    },
    // 设置expirationTime
    set_expirationTime(state, expirationTime) {
      this.state.expirationTime = expirationTime
    },
    // 设置effectiveMinutes
    set_effectiveMinutes(state, effectiveMinutes) {
      this.state.effectiveMinutes = effectiveMinutes
    },
    // 设置菜单列表
    set_menulist(state, menulist) {
      this.state.menulist = menulist
    },
    // 设置clientHeight
    set_clientHeight(state, clientHeight) {
      this.state.clientHeight = clientHeight
    },
    // 设置侧边栏当前选中项
    set_activeIndex(state, activeIndex) {
      this.state.activeIndex = activeIndex
    },
    // 设置clientWidth
    set_clientWidth(state, clientWidth) {
      this.state.clientWidth = clientWidth
    },
    // 设置showLoading
    set_showLoading(state, num) {
      this.state.showLoading = Number(state.showLoading) + Number(num)
    },
    // 关闭loding
    set_shutloader() {
      this.state.showLoading = 0
    },
    // 注销
    set_logout(state, bool) {
      this.state.logout = bool
    },
    // 当前选中的产品类型
    set_productType(state, productType) {
      this.state.productType = productType
    },
    // 设置系统设置
    set_systemSettingByObj(state, Obj) {
      state.systemSetting = Obj
    },
    // 设置系统设置
    set_systemSettingByKey(state, key, value) {
      state.systemSetting[key] = value
    }
  },
  actions: {
    showloader: ({ commit }) => {
      commit('set_showLoading', 1)
    },
    hideloader: ({ commit }) => {
      commit('set_showLoading', -1)
    },
    shutloader: ({ commit }) => {
      commit('set_shutloader')
    }
  },
  modules: {}
})
